import React from 'react';
import SuperStore from './DataStore/SuperStore';
import AppInitializer from './pages/Welcome/AppInitializer';

const App = () => (
         <SuperStore>
            <AppInitializer />
          </SuperStore>
);

export default App;
